import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

export default class RegionInput extends Component {
  static propTypes = {
    regionSuggestionsUrl: PropTypes.string,
    initialValue: PropTypes.array,
    inputName: PropTypes.string,
    multiValue: PropTypes.bool,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    onRemove: PropTypes.func,
    onAdd: PropTypes.func,
  }

  static defaultProps = {
    multiValue: true,
    placeholder: 'Start typing to see suggestions...',
    required: false,
    onRemove: null,
    onAdd: null,
  }

  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
      value: this.props.initialValue.map(v => ({ display: this.removeCountry(v.name_with_path), id: v.id })),
      suggestions: [],
      selectedSuggestionIndex: 0,
    };
  }

  highlight(query, str) {
    const countrySeparatorIndex = str.indexOf('|');
    let beforeCountry = str;
    let country = '';

    if (countrySeparatorIndex !== -1) {
      beforeCountry = str.slice(0, countrySeparatorIndex);
      country = str.slice(countrySeparatorIndex + 1);
    }

    if (country.length !== 0) {
      country = (
        <span className="u-text-old-dark-grey u-ml-2">
          {country}
        </span>
      );
    }

    const highlightIndex = beforeCountry.toLowerCase().indexOf(query);
    let beforeHighlight = beforeCountry;
    let it = '';
    let afterHighlight = '';
    if (highlightIndex !== -1) {
      beforeHighlight = beforeCountry.slice(0, highlightIndex);
      it = beforeCountry.slice(highlightIndex, highlightIndex + query.length);
      afterHighlight = beforeCountry.slice(highlightIndex + query.length);
    }

    if (it.length !== 0) {
      it = (
        <strong>
          {it}
        </strong>
      );
    }

    return (
      <span>
        {beforeHighlight}
        {it}
        {afterHighlight}
        {country}
      </span>
    );
  }

  removeCountry(str) {
    return str.slice(0, str.indexOf('|'));
  }

  loadSuggestions(query) {
    $.ajax({
      type: 'GET',
      url: this.props.regionSuggestionsUrl,
      data: {
        query,
      },
      success: (data) => {
        const suggestions = data.map(
          datum => ({
            display: this.removeCountry(datum.name_with_path),
            highlitDisplay: this.highlight(query, datum.name_with_path),
            id: datum.id,
          })
        );
        // initialize selected suggestion
        if (suggestions.length > 0) {
          suggestions[0].selected = true;
        }
        this.setState({
          suggestions,
          selectedSuggestionIndex: 0,
        });
      },
    });
  }

  removeResult(key) {
    const index = this.state.value.findIndex(element => element.id === key);
    const newValue = this.state.value.slice();
    const oldValues = newValue.splice(index, 1);
    this.setState({
      value: newValue,
    }, () => this.valueRemoved(oldValues[0]));
  }

  handleChange = (e) => {
    const value = e.target.value;
    if (value.length >= 3) {
      // load suggestions
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.loadSuggestions(value);
      }, 150);
      this.setState({
        inputValue: value,
      });
    } else {
      this.setState({
        selectedSuggestionIndex: 0,
        suggestions: [],
        inputValue: value,
      });
    }
  }

  hover(index) {
    this.setState({
      selectedSuggestionIndex: index,
    });
  }

  valueAdded = (v) => {
    if (this.props.onAdd) {
      this.props.onAdd(v);
    }
  }

  valueRemoved = (v) => {
    if (this.props.onRemove) {
      this.props.onRemove(v);
    }
  }

  pickSuggestion(index) {
    // shallow copy array;
    const newValue = this.state.value.slice();
    // get new value from selected suggestion;
    newValue.push(this.state.suggestions[index]);
    this.setState({
      inputValue: '',
      value: newValue,
      suggestions: [],
      selectedSuggestionIndex: 0,
    }, this.valueAdded.bind(this, this.state.suggestions[index]));
  }

  handleBlur = () => {
    setTimeout(() => {
      this.setState({
        inputValue: '',
        suggestions: [],
        selectedSuggestionIndex: 0,
      });
    }, 200);
  }

  handleKeyDown = (e) => {
    switch (e.which) {
      case 40: // Down Arrow
        if (this.state.suggestions.length > 0) {
          e.preventDefault();
          e.stopPropagation();

          this.setState({
            selectedSuggestionIndex: Math.min(this.state.selectedSuggestionIndex + 1, this.state.suggestions.length - 1),
          });
        }
        break;
      case 38: // Up Arrow
        if (this.state.suggestions.length > 0) {
          e.preventDefault();
          e.stopPropagation();

          this.setState({
            selectedSuggestionIndex: Math.max(this.state.selectedSuggestionIndex - 1, 0),
          });
        }
        break;
      case 13: // Enter key
      case 9: // tab key
        if (this.state.suggestions.length > 0) {
          e.preventDefault();
          e.stopPropagation();
          this.pickSuggestion(this.state.selectedSuggestionIndex);
        }
        break;
      case 27: // Esc key
        this.handleBlur();
        break;
      default:
        break;
    }
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.initialValue) !== JSON.stringify(this.props.initialValue)) {
      const newState = update(this.state, { value: { $set: this.props.initialValue.map(v => ({ display: this.removeCountry(v.name_with_path), id: v.id })) } });
      this.setState(newState);
    }
  }

  render() {
    let emptySuggestions = '';

    if (this.state.suggestions.length === 0 && this.state.inputValue.length > 3) {
      const notice = "Can't find your city? Try something less specific or contact support to suggest additions.";
      emptySuggestions = (
        <li>
          {notice}
        </li>
      );
    }

    let textField = '';
    if (this.state.value.length === 0 || this.props.multiValue === true) {
      textField = (
        <input
          type="text"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          placeholder={this.props.placeholder}
          value={this.state.inputValue}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          onBlur={this.handleBlur}
          className={this.props.required ? 'required' : 'optional'}
        />
      );
    }

    return (
      <div className="RegionInput">
        {textField}
        <div className="RegionInput-wrapper u-mt-2">
          <ul>
            {
              this.state.suggestions.map(
                (suggestion, i) => {
                  const highlighted = this.state.selectedSuggestionIndex === i ? 'u-bg-old-highlight-color' : '';
                  return (
                    <li
                      key={i}
                      className={highlighted}
                      onMouseOver={() => this.hover(i)}
                      onClick={() => this.pickSuggestion(i)}
                    >
                      <i className="Icon-map-marker Icon" />
                      {suggestion.highlitDisplay}
                    </li>
                  );
                }
              )
            }
            {emptySuggestions}
          </ul>
          { Object.keys(this.state.value).length > 0 &&
            <div className="RegionInput-results u-pb-3">
              {
                this.state.value.map(
                  value => (
                    <span key={value.id}>
                        {value.display}
                      <span
                        className="RegionInput-results-close"
                        onClick={
                          () => {
                            this.removeResult(value.id);
                          }
                        }
                      >
                          &times;
                        </span>
                        <input name={this.props.inputName} type="hidden" value={value.id}/>
                      </span>
                  )
                )
              }
            </div>
          }
        </div>
        <input name={this.props.inputName} type="hidden" value="" />
      </div>
    );
  }
}
